
function verifyAge() {
  const month = parseInt(document.getElementById('dob-month').value);
  const day = parseInt(document.getElementById('dob-day').value);
  const year = parseInt(document.getElementById('dob-year').value);

  if (!month || !day || !year) {
    alert("Please select your full date of birth.");
    return;
  }

  const birthDate = new Date(year, month - 1, day);
  const today = new Date();
  const age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  const d = today.getDate() - birthDate.getDate();

  const is21 = (age > 21) || (age === 21 && (m > 0 || (m === 0 && d >= 0)));

  if (is21) {
    localStorage.setItem("ageVerified", "true");
    document.getElementById("age-verification").style.display = "none";
  } else {
    alert("You must be 21 or older to enter this site.");
  }
}


window.onload = () => {
  if (localStorage.getItem("ageVerified") !== "true") {
    document.getElementById("age-verification").style.display = "flex"; 
  }
};

